import { ChatBoxElement } from '../packages/ffp-chatbox/index';
import { glue } from '../packages/ffp-chatbox/glue';

const TAG_NAME = 'ffp-chatbox';

function glueWhenReady() {
  const alreadyGlued = new Set();

  const tryGlue = () => {
    const els = document.querySelectorAll(TAG_NAME);
    els.forEach((el) => {
      if (!alreadyGlued.has(el)) {
        glue(el as ChatBoxElement);
        alreadyGlued.add(el);
      }
    });
  };

  // Try immediately in case it's already there
  tryGlue();

  // Watch DOM changes
  const observer = new MutationObserver(() => {
    tryGlue();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

glueWhenReady()